import {useCallback, useEffect, useState} from "react";
import { allCountries } from 'country-region-data';
import {Select} from "@shopify/polaris";

const CountryNameKey = 0;
const CountrySlugKey = 1;
const CountryRegionsKey = 2;

const RegionNameKey = 0;
const RegionSlugKey = 1;

const defaultCountry = 'US';

export const CountrySelector = ({value, onChange = () => {}, error, disabled = false}) => {

    useEffect(() => {
        if (!value || value.trim() === '') {
            onChange(defaultCountry);
        }
    }, [value, onChange]);

    const getOptions = () => {
        return allCountries.map((country) => {
            return {
                value: country[CountrySlugKey],
                label: country[CountryNameKey]
            };
        });
    };

    const normalizedValue = value && value.trim() !== '' ? value : defaultCountry;

    return (<>
        <Select
            placeholder={"- Select Country -"}
            label={"Country"}
            options={getOptions()}
            value={normalizedValue}
            onChange={onChange}
            error={error}
            disabled={disabled}
        ></Select>
    </>)
}

export const StateSelector = ({value =  '', onChange = () => {}, selectedCountry = '', error, disabled = false}) => {
    const normalizedCountryValue = selectedCountry && selectedCountry.trim() !== '' ? selectedCountry : defaultCountry;

    const getOptions = () => {
        let regions = [];

        allCountries.forEach((country) => {
            if (country[CountrySlugKey] === normalizedCountryValue) {
                regions = country[CountryRegionsKey];
            }
        });

        return regions.map((region) => {
            return {
                value: region[RegionSlugKey],
                label: region[RegionNameKey]
            };
        });
    };

    const options = getOptions();

    useEffect(() => {
        if (value && !options.find(opt => opt.value === value)) {
            onChange('');
        }
    }, [normalizedCountryValue, value, onChange]);

    return (<>
        <Select
            placeholder={"- Select State -"}
            label={"State"}
            options={options}
            value={value}
            onChange={onChange}
            error={error}
            disabled={disabled}
        ></Select>
    </>)
}
